import { Component, Inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JkBaseOption, jkRestReturn } from 'jk-service';
import { MaterialModule, } from "jk-service";
import { TaxwdService, templateUrlConfigTax } from '../_service_tax';
import { Taxwd } from '../_entity_tax';
import { JkDialogEditComponent } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { JkbtneditComponent } from 'jk-advcom';


@Component({
  selector: 'app-taxwd-edit',
  templateUrl: 'taxwd-editPkg.component.html',
  styleUrls: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [JackBaseComponentModule,
    //JkaggridComponent,
    JkbtneditComponent, MaterialModule],
})

export class TaxwdEditComponent extends JkDialogEditComponent<TaxwdService, Taxwd> {
  override srv!: TaxwdService;
  constructor(
    inject: Injector,
    public override dialogRef: MatDialogRef<TaxwdEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: jkRestReturn
  ) {
    super(inject, dialogRef, data);
  }


}
